import {REFER_AND_EARN_ENABLED} from '../constant/features';
import React from "react";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PeopleIcon from "@mui/icons-material/People";
import HomeIcon from "@mui/icons-material/Home";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import CasinoIcon from "@mui/icons-material/Casino";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate, useLocation } from "react-router-dom";
import { Colors } from "../utils/colors";

const actionSx = { color: 'whitesmoke', '&.Mui-selected': { color: Colors.accent } };

export default function BottomNav() {

  const navigate = useNavigate();
  const location = useLocation();

  return (

    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1200,
        backgroundColor: Colors.secondary,
        pb: "env(safe-area-inset-bottom, 0px)"
      }}
      elevation={3}
    >

      <BottomNavigation
        aria-label="Main navigation"
        value={location.pathname}
        onChange={(e, value) => navigate(value)}
        showLabels
        sx={{
          backgroundColor: Colors.secondary,
          height: 84,
          alignItems: "stretch",

          "& .MuiBottomNavigationAction-root": {
            color: 'whitesmoke',
            minWidth: '0 !important',
            maxWidth: "none",
            width: "auto",
            flex: '1 1 0',
            paddingLeft: "1px",
            paddingRight: "1px",
            paddingTop: "8px",
            paddingBottom: "8px",
            gap: "4px",
            alignItems: "center",
            justifyContent: "center",
            overflow: "visible"
          },

          "& .MuiBottomNavigationAction-label": {
            fontSize: "clamp(12px, 3.35vw, 14px)",
            fontWeight: 600,
            lineHeight: "16px",
            minHeight: "32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: 'center',
            whiteSpace: 'pre',
            letterSpacing: 0,
            "&.Mui-selected": { fontSize: "clamp(12px, 3.35vw, 14px)" }
          },

          "& .MuiSvgIcon-root": {
            fontSize: "24px",
            flexShrink: 0
          }
        }}
      >

        <BottomNavigationAction sx={actionSx}
          label="Home"
          value="/"
          icon={<HomeIcon />}
        />

        <BottomNavigationAction sx={actionSx}
          aria-label="Buy Ticket" label={"Buy\nTicket"}
          value="/buy"
          icon={<ConfirmationNumberIcon />}
        />

        <BottomNavigationAction sx={actionSx}
          aria-label="Live Draw" label={"Live\nDraw"}
          value="/draw"
          icon={<CasinoIcon />}
        />

        <BottomNavigationAction sx={actionSx}
          label="Results"
          value="/winners"
          icon={<EmojiEventsIcon />}
        />

        <BottomNavigationAction sx={actionSx}
          label="Profile"
          value="/account/authmenu"
          icon={<AccountCircleIcon />}
        />

        {REFER_AND_EARN_ENABLED && <BottomNavigationAction sx={actionSx} aria-label="Refer & Earn" label={"Refer &\nEarn"} value="/refer-and-earn" icon={<PeopleIcon />} />}
        <BottomNavigationAction sx={actionSx} aria-label="About Us" label={"About\nUs"} value="/about-us" icon={<InfoOutlinedIcon />} />
      </BottomNavigation>

    </Paper>
  );
}
